(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["clix-hero"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var scatterEls = document.querySelectorAll('[id^="clix-scatter-"]');
    var colors = ['#FF5A4E','#F3D9C4','#141414','#E7C979','#EFC3D2'];
    scatterEls.forEach(function(el){
      if (el.dataset.clixInit) return;
      el.dataset.clixInit = '1';
      for (var i = 0; i < 7; i++) {
        var s = document.createElement('div');
        s.className = 'clix-hero__swatch';
        var size = 40 + Math.random() * 70;
        s.style.width = size + 'px';
        s.style.height = (size * 1.3) + 'px';
        s.style.left = Math.random() * 80 + '%';
        s.style.top = Math.random() * 80 + '%';
        s.style.background = colors[i % colors.length];
        s.style.opacity = 0.85;
        s.style.transform = 'rotate(' + (Math.random() * 40 - 20) + 'deg)';
        el.appendChild(s);
      }
    });

    document.querySelectorAll('.clix-ripple-btn').forEach(function(btn){
      if (btn.dataset.clixRippleInit) return;
      btn.dataset.clixRippleInit = '1';
      btn.addEventListener('click', function(e){
        var circle = document.createElement('span');
        var d = Math.max(btn.clientWidth, btn.clientHeight);
        var rect = btn.getBoundingClientRect();
        circle.style.position = 'absolute';
        circle.style.borderRadius = '50%';
        circle.style.background = '#FF5A4E';
        circle.style.opacity = '.55';
        circle.style.pointerEvents = 'none';
        circle.style.width = circle.style.height = d + 'px';
        circle.style.left = (e.clientX - rect.left - d / 2) + 'px';
        circle.style.top = (e.clientY - rect.top - d / 2) + 'px';
        circle.style.transform = 'scale(0)';
        circle.style.transition = 'transform .6s ease-out, opacity .6s ease-out';
        btn.appendChild(circle);
        requestAnimationFrame(function(){
          circle.style.transform = 'scale(3)';
          circle.style.opacity = '0';
        });
        setTimeout(function(){ circle.remove(); }, 650);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clix-popup"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var popups = document.querySelectorAll('.clix-popup');
    popups.forEach(function(popup){
      if (popup.dataset.clixInit) return;
      popup.dataset.clixInit = '1';
      var shown = false;
      try { shown = localStorage.getItem('clix_popup_seen'); } catch(e) {}
      if (!shown) {
        setTimeout(function(){
          popup.classList.add('clix-popup--open');
          document.body.style.overflow = 'hidden';
        }, 2500);
      }
      function closePopup(){
        popup.classList.remove('clix-popup--open');
        document.body.style.overflow = '';
        try { localStorage.setItem('clix_popup_seen', '1'); } catch(e) {}
      }
      popup.querySelectorAll('[data-clix-popup-close]').forEach(function(btn){
        btn.addEventListener('click', closePopup);
      });
      document.addEventListener('keydown', function(e){
        if (e.key === 'Escape') closePopup();
      });
      var form = popup.querySelector('.clix-popup__form');
      if (form) {
        form.addEventListener('submit', function(){
          try { localStorage.setItem('clix_popup_seen', '1'); } catch(e) {}
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
